import wardrobeImage from "../assets/wardrobe-interface.jpeg";
import secondImage from "../assets/wardrobe-interface2.jpeg"; // You'll need these images
import thirdImage from "../assets/wardrobe-interface3.jpeg";
import fourthImage from "../assets/wardrobe-interface4.jpeg";
import collectionImageOne from "./../assets/collection-image-one.png";
import collectionImageTwo from "./../assets/collection-image-two.jpg";
import collectionImageThree from "./../assets/collection-image-three.jpg";
import collectionImageFour from "./../assets/collection-image-four.png";
import collectionImageFive from "./../assets/collection-image-five.jpg";
import collectionImageSix from "./../assets/collection-image-six.png";
import collectionImageSeven from "./../assets/collection-image-seven.png";
import collectionImageEight from "./../assets/collection-image-eight.png";
import collectionImageNine from "./../assets/collection-image-nine.png";
import collectionImageTen from "./../assets/collection-image-ten.jpg";
import collectionImageEleven from "./../assets/collection-image-eleven.jpg";
import collectionImageTwelve from "./../assets/collection-image-twelve.png";
import collectionImageThirteen from "./../assets/collection-image-thirteen.png";

export const products = [
  {
    image: require("../assets/dress1.png"),
    match: "90",
    name: "Carrie Dress - White",
    price: "390",
    is_landing_page: true,
  },
  {
    image: require("../assets/dress2.png"),
    match: "85",
    name: "Natasha Dress - Black",
    price: "290",
    is_landing_page: true,
  },
  {
    image: require("../assets/dress3.png"),
    match: "92",
    name: "Eloise Dress - Black",
    price: "260",
    is_landing_page: true,
  },
  {
    image: require("../assets/dress4.png"),
    match: "76",
    name: "Sophie Dress - Silver",
    price: "350",
    is_landing_page: true,
  },
];

export const marketplaceProducts = [
  {
    image: require("../assets/preview1.png"),
    match: "90",
    name: "Short Dress with Bows",
    price: "660",
  },
  {
    image: require("../assets/preview2.png"),
    match: "85",
    name: "Ribbed Godet Dress",
    price: "660",
  },
  {
    image: require("../assets/wide-image1.png"),
    match: "90",
    face_match: "76",
    filters: ["Perfect Colour", "MEN"],
    name: "Short Dress with Bows",
    price: "660",
  },
  {
    image: require("../assets/preview3.png"),
    match: "92",
    name: "Starpless Midi Dress",
    price: "660",
  },
  {
    image: require("../assets/preview4.png"),
    match: "76",
    name: "Draped Midi Dress",
    price: "660",
  },
  {
    image: require("../assets/wide-image2.png"),
    match: "85",
    face_match: "70",
    filters: ["Perfect Fit"],
    name: "Ribbed Godet Dress",
    price: "660",
  },
  {
    image: require("../assets/wide-image3.png"),
    match: "92",
    face_match: "90",
    filters: ["Perfect Color"],
    name: "Starpless Midi Dress",
    price: "660",
  },
  {
    image: require("../assets/wide-image4.png"),
    match: "76",    
    face_match: "90",
    name: "Draped Midi Dress",
    price: "660",
  },
];

export const marketplaceItems = [
  {
    image: require("../assets/jeans.png"),
    name: "Jeans",
  },
  {
    image: require("../assets/shoes.png"),
    name: "Shoes",
  },
  {
    image: require("../assets/bags.png"),
    name: "Bags",
  },
  {
    image: require("../assets/eyewear.png"),
    name: "Eyewear",
  },
];

export const landingPageNavItems = [
  // { label: "About", path: "/about" },
  // { label: "Terms", path: "/terms" },
  { label: "Login", path: "/login" },
  { label: "Get Started", path: "/signup" },
  { label: "Collection", path: "/shop" },
  { label: "Marketplace", path: "/marketplace" },
  { label: "Eveness GPT", path: "/evenessgpt" },
  { label: "Blog", path: "/blog" },
];

export const homePageNavItems = [
  { label: "Marketplace", path: "/marketplace", textColor: "text-black" },
  { label: "Dashboard", path: "/dashboard" },
  { label: "Collection", path: "/shop" },
  { label: "Eveness GPT", path: "/evenessgpt" },
  // { label: "Magazine", path: "/magazine"},
  { label: "Account", path: "/account" },
];

export const LoginPageNavItems = [
  // { label: "About", path: "/about" },
  // { label: "Terms", path: "/terms" },
  { label: "Login", path: "/login" },
  { label: "Get Started", path: "/signup" },
  { label: "Collection", path: "/shop" },
  { label: "Marketplace", path: "/marketplace" },
  { label: "Eveness GPT", path: "/evenessgpt" },
  { label: "Blog", path: "/blog" },
];

export const brandStorySections = [
  {
    imageOnRight: true,
    title: "The House of\nSymmetry",
    description:
      "Our story starts with a simple question: Who? Once we know whom we're designing for, we craft the perfect silhouette to balance and accentuate their shape.",
    buttonText: "Accentuate My Figure",
    url: "/signup",
    image: wardrobeImage,
  },
  {
    imageOnRight: false,
    title: "Personalized \nFashion Dashboard",
    description:
      "Learn the best colors, silhouettes, and necklines based on your Color Analysis, Face, and Body Shape. ",
    buttonText: "Explore Color Analysis and \nAccentuate my Figure",
    url: "/signup",
    image: secondImage,
  },
  {
    imageOnRight: true,
    title: "Eveness \nMarketplace",
    description:
      "The Eveness Algorithm expanded to more than the collection. Shop from a variety of brands with our help pieces that highlight you.",
    buttonText: "Access My Marketplace",
    url: "/signup",
    image: thirdImage,
  },
  {
    imageOnRight: false,
    title: "Eveness GPT",
    description:
      "The Eveness GPT is your on the go fashion stylist. Find out whether a garment matches your features and how to style it.",
    buttonText: "My Personal AI Stylist",
    url: "/signup",
    image: fourthImage,
  },
];

export const marketplacePreviewProducts = [
  { image: require("../assets/jeans.png"), name: "Jeans" },
  { image: require("../assets/heels.png"), name: "Shoes" },
  { image: require("../assets/bags.png"), name: "Bags" },
  { image: require("../assets/eyewear.png"), name: "Eyewear" },
  { image: require("../assets/heels.png"), name: "Shoes" },
  { image: require("../assets/jeans.png"), name: "Jeans" },
  { image: require("../assets/eyewear.png"), name: "Eyewear" },
  { image: require("../assets/bags.png"), name: "Bags" },
];

export const testimonials = [
  {
    quote:
      "Our mission is to help people accentuate their favorite parts of themselves—even if it sacrifices profit. We also build our technology to have integrations because we believe empowerment is better than competition. And in our goal of empowerment, we start by understanding you—so we can build your best experience.",
    author: "Amir Razipour",
    title: "CEO and Founder",
  },
  // Add more testimonials here
];

export const landingPageProducts = [
  {
    id: 1,
    name: "Black Mini Dress",
    brand: "Reformation",
    price: "$250",
    image: collectionImageOne,
  },
  {
    id: 2,
    name: "Red Puff Sleeve Dress",
    brand: "Reformation",
    price: "$250",
    image: collectionImageTwo,
  },
  {
    id: 3,
    name: "Green Mini Dress",
    brand: "Reformation",
    price: "$250",
    image: collectionImageThree,
  },
  {
    id: 4,
    name: "Black Midi Dress",
    brand: "Reformation",
    price: "$250",
    image: collectionImageFour,
  },
  {
    id: 5,
    name: "Pink Satin Dress",
    brand: "Reformation",
    price: "$250",
    image: collectionImageSeven,
  },
  {
    id: 6,
    name: "Black Slip Dress",
    brand: "Reformation",
    price: "$250",
    image: collectionImageNine,
  },
  {
    id: 7,
    name: "Silver Midi Dress",
    brand: "Reformation",
    price: "$198",
    image: collectionImageFour,
  },
  {
    id: 8,
    name: "Cream Satin Dress",
    brand: "Reformation",
    price: "$250",
    image: collectionImageFour,
  },

  {
    id: 9,
    name: "Silver Midi Dress",
    brand: "Reformation",
    price: "$198",
    image: collectionImageTen,
  },
  {
    id: 10,
    name: "Cream Satin Dress",
    brand: "Reformation",
    price: "$250",
    image: collectionImageTwelve,
  },
  {
    id: 11,
    name: "Cream Satin Dress",
    brand: "Reformation",
    price: "$250",
    image: collectionImageThirteen,
  },
  {
    id: 12,
    name: "Cream Satin Dress",
    brand: "Reformation",
    price: "$250",
    image: collectionImageEleven,
  },
];

export const lifestyleImages = [
  collectionImageFive,
  collectionImageSix,
  collectionImageEight,
];
